import { fetchApiHub } from '@frontastic-engbers/lib';

export const queryProductsByIds = async (productIds: string[]) => {
  const params = productIds.map((id) => `productIds[]=${id}`).join('&');
  const res = await fetchApiHub(`/action/product/query?${params}`);

  return res.items;
};
